import { Injectable, Inject } from '@angular/core';

import { EnvironmentModuleConfigToken, IEnvironmentModuleConfig } from './environment-module-config';

@Injectable()
export class EnvironmentService {
    constructor(@Inject(EnvironmentModuleConfigToken) public config: IEnvironmentModuleConfig) {}
}
